export default "__VITE_ASSET__DRtWdPAa__"